import React from "react";

import "./index.css";

class AddBranchModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      firstline: "",
      townCity: "",
      postcode: "",
      capacity: "",
      openingTime: "",
      closingTime: "",
    };
  }

  componentDidUpdate(prevProps) {
    console.log(prevProps, this.props);
    const { initialValues } = this.props;
    console.log(initialValues);
    if (prevProps.initialValues !== initialValues) {
      if (initialValues) {
        this.setState({
          firstline: initialValues.firstline,
          townCity: initialValues.townCity,
          postcode: initialValues.postcode,
          capacity: initialValues.capacity,
          openingTime: initialValues.openingTime,
          closingTime: initialValues.closingTime,
        });
      } else {
        this.setState({
          firstline: "",
          townCity: "",
          postcode: "",
          capacity: "",
          openingTime: "",
          closingTime: "",
        });
      }
    }
  }

  onChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  addBranch = () => {
    const {
      firstline,
      townCity,
      postcode,
      capacity,
      openingTime,
      closingTime,
    } = this.state;
    const { addBranch } = this.props;
    addBranch({
      firstline,
      townCity,
      postcode,
      capacity,
      openingTime,
      closingTime,
    });
    this.reset();
  };

  reset = () => {
    this.setState({
      firstline: "",
      townCity: "",
      postcode: "",
      capacity: "",
      openingTime: "",
      closingTime: "",
    });
  };

  render() {
    const {
      firstline,
      townCity,
      postcode,
      capacity,
      openingTime,
      closingTime,
    } = this.state;
    return (
      <div
        className="modal fade"
        id="add_branch"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog add-branch-modal" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Branch</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1">
              <div className="form-group">
                <p>First Line</p>
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt"
                  id="addbranch-firstline"
                  name="firstline"
                  onChange={this.onChangeHandler}
                  value={firstline}
                />
              </div>
              <div className="form-group">
                <p>Town/City</p>
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt"
                  id="addbranch-townCity"
                  name="townCity"
                  onChange={this.onChangeHandler}
                  value={townCity}
                />
              </div>
              <div className="form-group">
                <p>Postcode</p>
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt"
                  id="addbranch-postcode"
                  name="postcode"
                  onChange={this.onChangeHandler}
                  value={postcode}
                />
              </div>
              <div className="form-group">
                <p>Capacity</p>
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt"
                  id="addbranch-capacity"
                  name="capacity"
                  onChange={this.onChangeHandler}
                  value={capacity}
                />
              </div>
              <div className="form-group">
                <p>Opening time</p>
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt"
                  id="addbranch-openingTime"
                  name="openingTime"
                  onChange={this.onChangeHandler}
                  value={openingTime}
                />
              </div>
              <div className="form-group">
                <p>Closing time</p>
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt"
                  id="addbranch-closingTime"
                  name="closingTime"
                  onChange={this.onChangeHandler}
                  value={closingTime}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-light"
                data-dismiss="modal"
                onClick={this.reset}
              >
                Close
              </button>
              {this.props.initialValues && (
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  data-dismiss="modal"
                  onClick={this.props.deleteBranch}
                >
                  Delete
                </button>
              )}
              <button
                type="button"
                className="btn btn-sm btn-success"
                data-dismiss="modal"
                onClick={this.addBranch}
                disabled={
                  !firstline ||
                  !townCity ||
                  !postcode ||
                  !capacity ||
                  !openingTime ||
                  !closingTime
                }
              >
                {this.props.initialValues ? "Save" : "Add"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddBranchModal;



// WEBPACK FOOTER //
// ./src/components/AddBranchModal/index.js